<template>
  <div id="InvoiceApproval">
    <eb-header>
      <eb-break-crumb slot="breakCrumb" />
    </eb-header>
    <div class="panel-box">
      <eb-panel>
        <eb-panel-header slot="header">
          <span slot="title">申请信息</span>
        </eb-panel-header>
        <div slot="body">
          <div class="row-field">
            <div class="row-left">申请单位</div>
            <div class="row-right">{{invoice.applyOrgName}}</div>
          </div>
          <div class="row-field">
            <div class="row-left">申请人</div>
            <div class="row-right">{{invoice.applyUserName}}</div>
          </div>
          <div class="row-field">
            <div class="row-left">申请时间</div>
            <div class="row-right">{{invoice.applyTime | dateTimeStandardFormatZh}}</div>
          </div>
          <div class="row-field">
            <div class="row-left">申请金额</div>
            <div class="row-right">{{invoice.invoiceMoney}}元</div>
          </div>
        </div>
      </eb-panel>
    </div>
    <div class="eb-line"></div>
    <div class="panel-box">
      <eb-panel>
        <eb-panel-header slot="header">
          <span slot="title">关联订单</span>
        </eb-panel-header>
        <div slot="body" style="margin-top:10px;">
          <ebHandsontableView :hotSettings="hotSettings" class="panel-handsontable" />
        </div>
      </eb-panel>
    </div>
    <div class="eb-line"></div>
    <div class="panel-box">
      <eb-panel>
        <eb-panel-header slot="header">
          <span slot="title">发票信息</span>
        </eb-panel-header>
        <div slot="body">
          <div class="row-field">
            <div class="row-left">发票类型</div>
            <div class="row-right">{{invoiceType(invoice.invoiceType)}}</div>
          </div>
          <div class="row-field">
            <div class="row-left">单位名称</div>
            <div class="row-right">{{invoice.companyName}}</div>
          </div>
          <div class="row-field">
            <div class="row-left">纳税人识别码</div>
            <div class="row-right">{{invoice.creditCode}}</div>
          </div>
          <div class="row-field">
            <div class="row-left">注册地址</div>
            <div class="row-right">{{invoice.registerAddress}}</div>
          </div>
          <div class="row-field">
            <div class="row-left">注册电话</div>
            <div class="row-right">{{invoice.registerPhone}}</div>
          </div>
          <div class="row-field">
            <div class="row-left">开户银行</div>
            <div class="row-right">{{invoice.openBank}}</div>
          </div>
          <div class="row-field">
            <div class="row-left">银行账户</div>
            <div class="row-right">{{invoice.bankAccount}}</div>
          </div>
        </div>
      </eb-panel>
    </div>
    <div class="eb-line"></div>
    <div class="panel-box">
      <eb-panel>
        <eb-panel-header slot="header">
          <span slot="title">发票接收信息</span>
        </eb-panel-header>
        <div slot="body">
          <div class="row-field">
            <div class="row-left">接收地址</div>
            <div class="row-right">{{invoice.receiveAddress}}</div>
          </div>
          <div class="row-field">
            <div class="row-left">联系人</div>
            <div class="row-right">{{invoice.receiveUser}}</div>
          </div>
          <div class="row-field">
            <div class="row-left">手机号</div>
            <div class="row-right">{{invoice.receivePhone}}</div>
          </div>
        </div>
      </eb-panel>
    </div>
    <div class="eb-line"></div>
    <el-form label-width="110px">
      <div class="panel-box">
        <eb-panel>
          <eb-panel-header slot="header">
            <span slot="title">发票状态及备注</span>
          </eb-panel-header>
          <div slot="body">
            <div class="row-field">
              <div class="row-left">发票状态</div>
              <div class="row-right">
                <el-radio-group v-model="invoice.invoiceStatus">
                  <el-radio class="eb-radio radio" label="0">未开</el-radio>
                  <el-radio class="eb-radio radio" label="1">已开</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div class="row-field">
              <div class="row-left">添加备注</div>
              <div class="row-right">
                <el-input type="textarea" v-model="invoice.invoiceRemark" :value="invoice.invoiceRemark" :rows="5" :maxlength="100" placeholder="发票备注" class="eb-textarea inputWidth"></el-input>
              </div>
            </div>
          </div>
        </eb-panel>
      </div>
      <div class="eb-line"></div>
      <div class="panel-box">
        <div class="eb-button-group width">
          <el-button class="eb-button-group-btn eb-button-orange eb-button-big" @click="resetForm()">取消</el-button>
          <el-button class="eb-button-group-btn eb-button-orange eb-button-big" @click="confirmForm()">确认</el-button>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import ebHeader from '@/components/common/eb-header';
import ebBreakCrumb from '@/components/common/eb-break-crumb';
import ebPanel from '@/components/common/panel/eb-panel';
import ebPanelHeader from '@/components/common/panel/eb-panel-header';
import ebHandsontableView from '@/components/common/eb-handsontable-view';
import { findInvoiceById, updateInvoiceStatus } from '@/services/invoice-service';
export default {
  name: 'InvoiceApproval',
  components: {
    ebHeader,
    ebBreakCrumb,
    ebPanel,
    ebPanelHeader,
    ebHandsontableView
  },
  data() {
    return {
      invoiceId: this.$route.params.invoiceId,
      initStatus: '',
      invoice: {},
      hotSettings: {
        rowHeaders: true,
        startRows: 1,
        colHeaders: ['订单编号', '订单类型', '付款金额'],
        renderAllRows: true,
        fillHandle: false,
        data: [],
        columns: [
          {
            data: 'sysOrderNumber',
            type: 'text',
            width: 200,
            className: 'htCenter',
            readOnly: true
          },
          {
            data: 'orderType',
            type: 'text',
            readOnly: true,
            className: 'htCenter',
            width: 150,
            renderer: (instance, td, row, col, prop, value, cellProperties) => {
              let text = this.$options.filters['orderType'](value);
              let styleText = '<div style="text-align: center;">' + text + '</div>';
              td.innerHTML = styleText;
            }
          },
          {
            data: 'transationAmount',
            width: 120,
            type: 'numeric',
            readOnly: true,
            className: 'htCenter',
            numericFormat: {
              pattern: '0,0.00'
            },
            validator: 'numeric'
          }
        ]
      }
    };
  },
  created() {
    this.initInvoiceInfo();
  },
  methods: {
    async initInvoiceInfo() {
      try {
        let { data } = await findInvoiceById(this.invoiceId);
        if (data.returnCode === '01') {
          this.initStatus = data.sysInvoice.invoiceStatus;
          this.invoice = data.sysInvoice;
          this.hotSettings.data = data.paymentList;
        } else {
          this.$message.error('获取发票信息失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    invoiceType(type) {
      return this.$options.filters['invoiceType'](type);
    },
    invoiceStatus(status) {
      return this.$options.filters['invoiceStatus'](status);
    },
    resetForm() {
      this.$router.push('/sys/invoice');
    },
    confirmForm() {
      this.updateInvoiceInfo();
    },
    async updateInvoiceInfo() {
      let params = {
        invoiceId: this.invoice.invoiceId,
        invoiceStatus: this.invoice.invoiceStatus,
        invoiceRemark: this.invoice.invoiceRemark
      };
      try {
        let { data } = await updateInvoiceStatus(params);
        if (data.returnCode === '01') {
          this.$message.success('发票开具成功');
          this.$router.push('/sys/invoice');
        } else {
          this.$message.error('发票开具失败');
        }
      } catch (error) {
        this.$message.error('请检查服务器连接!');
      }
    }
  }
};
</script>
<style lang="less" scoped>
#InvoiceApproval {
  .panel-box {
    width: 90%;
    margin: 0 auto;
    padding-top: 30px;
    padding-bottom: 30px;
    .inputWidth {
      width: 530px;
    }
    .radio {
      margin-right: 40px;
    }
    .width {
      margin-left: -250px;
    }
    .quoteMin {
      margin-left: 530px;
      padding: 10px 10px 0 0;
      color: #fb5b3b;
    }
  }
  .row-field {
    width: 100%;
    min-height: 35px;
    line-height: 35px;
    margin-left: 0px;
    font-family: '微软雅黑';
    display: flex;
    flex-wrap: wrap;
    margin-top: 5px;
    .row-left {
      width: 110px;
      margin-left: 0px;
      margin-right: 15px;
    }
    .row-right {
      width: 66%;
      padding-right: 15px;
      padding-left: 30px;
    }
  }
  .panel-handsontable {
    padding-top: 7px;
    margin-left: 0px;
  }
}
</style>
